import {useMemo} from 'external/react'

import usePayment from 'context/payment-context/hook'

import WorkbooksSummary from './WorkbooksSummary'
import PaymentButton from './PaymentButton'


export default function Summaries() {
    const {packageItem} = usePayment()
    const [hasPackage, item] = useMemo(() => [!!packageItem, (packageItem || {}) as any], [packageItem])
    const {subTotal, discounted, discountAmountText} = item

    return (
        <div className='col-md-4'>
        {hasPackage && (
            <div className='card text-center'>
            <div className='card-header bg-white fw-bold'>
                Resumen de la compra
            </div>
            <div className='card-body'>
                <div className='d-flex justify-content-between'>
                    <p className='card-text fw-bold'>
                        <label className='text-capitalize'>
                            {item.offerName}
                        </label>{' '}
                        <small style={{ fontSize: '12px' }}>
                            ({item.frequency})
                        </small>
                    </p>
                        <p className='card-text'>$ {item.price.toFixed(2)}</p>
                    </div>
                    {item.workbooksCount > 0 && <WorkbooksSummary />}
                   <hr></hr>
                    <div className='d-flex justify-content-end'>
                        <p className='card-text fw-bold'>
                            <label className='text-capitalize mr-3'>
                                Subtotal:
                            </label>{' '}
                        </p>
                        <p className='card-text'>$ {subTotal.toFixed(2)}</p>
                    </div>
                </div>
                {discounted && (
                    <div className='d-flex justify-content-end'>
                        <p
                            className='card-text fw-bold'
                            style={{ marginRight: '50px' }}
                        >
                            Descuento:-{discountAmountText}
                        </p>
                        <p className='card-text'>- {discountAmountText}</p>
                   </div>
                )}
                <PaymentButton />
           </div>
       )} 
        </div>
    )
}